import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { CompanyPageCompanyFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import {
  SPOTTED_ZEBRA_SCORE_DATA_TEST_ID,
  SPOTTED_ZEBRA_SCORE_HELP_TEXT,
  SPOTTED_ZEBRA_SCORE_LABEL,
} from './SpottedZebraScoreSection.constants';
import SpottedZebraScoreSectionForm from './SpottedZebraScoreSectionForm';
import styles from './SpottedZebraScoreSection.module.scss';

type SpottedZebraScoreSectionProps = {
  company: CompanyPageCompanyFragment;
};

const SpottedZebraScoreSection = ({
  company,
}: SpottedZebraScoreSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);

  return isEditing ? (
    <SpottedZebraScoreSectionForm
      company={company}
      onCancelClick={() => setIsEditing(false)}
      onSave={() => setIsEditing(false)}
    />
  ) : (
    <div
      className={styles.viewContainer}
      data-testid={SPOTTED_ZEBRA_SCORE_DATA_TEST_ID}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{SPOTTED_ZEBRA_SCORE_LABEL}</h3>
        <Button
          variant="secondary"
          size="medium"
          onClick={() => setIsEditing(true)}
        >
          Edit
        </Button>
      </div>
      <div className={styles.content}>
        <InfoItem
          label={SPOTTED_ZEBRA_SCORE_LABEL}
          value={company.isSpottedZebraScoreEnabled ? 'Enabled' : 'Disabled'}
        />
        <p className={styles.helpText}>{SPOTTED_ZEBRA_SCORE_HELP_TEXT}</p>
      </div>
    </div>
  );
};

export default SpottedZebraScoreSection;
